if (typeof mapsData !== "undefined") {
    jQuery(mapsData).each(function(key, map) {
        initMap(key, map);
    });
}

function initMap(key, data) {
    var map;
    var uluru = {
        lat: parseFloat(data.lat),
        lng: parseFloat(data.lng)
    };
    map = new google.maps.Map(document.getElementById("map" + key), {
        zoom: 13,
        center: uluru,
        disableDefaultUI: true
    });
    var marker = new google.maps.Marker({ position: uluru, map: map });
}



// WEBPACK FOOTER //
// ./assets/js/maps.js